import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "rounded-lg border-0 relative"
};
import { reactive } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import { useMaxioSubscriptionStore } from './useMaxioSubscriptionStore.js';
export default {
  __name: 'StartSubscriptionModel',
  props: {
    alerts: {
      type: Object,
      required: false
    },
    plan: {
      type: Object,
      required: true
    }
  },
  emits: ['cancel', "subscription-updated"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const startSubscriptionState = reactive({
      openDialog: true,
      loading: false
    });
    const emit = __emit;
    const maxioCompanySubscriptionStore = useMaxioSubscriptionStore();
    maxioCompanySubscriptionStore.alerts = props.alerts;
    const startSubscription = async () => {
      startSubscriptionState.loading = true;
      if (!maxioCompanySubscriptionStore?.subscription?.product) {
        const response = await maxioCompanySubscriptionStore.createSubscriptionComponent({
          productId: props?.plan?.id,
          seats: maxioCompanySubscriptionStore?.subscription?.seatsRequired || maxioCompanySubscriptionStore?.subscription?.plan?.currentPaidSeats || maxioCompanySubscriptionStore?.subscription?.plan?.seats || 1,
          coupon: maxioCompanySubscriptionStore?.subscription?.couponCode || '',
          email: maxioCompanySubscriptionStore?.subscription?.billingEmail || ''
        });
        if (response && response.selfServicePaymentUrl) {
          window.location.href = response.selfServicePaymentUrl;
          startSubscriptionState.loading = false;
          startSubscriptionState.openDialog = false;
        }
      } else {
        await maxioCompanySubscriptionStore.changePlan(props.plan?.id);
        startSubscriptionState.loading = false;
        startSubscriptionState.openDialog = false;
        emit('subscription-updated');
      }
    };
    const cancel = () => {
      startSubscriptionState.openDialog = false;
      emit('cancel');
    };
    return (_ctx, _cache) => {
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_divider = _resolveComponent("v-divider");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_dialog = _resolveComponent("v-dialog");
      return _openBlock(), _createBlock(_component_v_dialog, {
        modelValue: startSubscriptionState.openDialog,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => startSubscriptionState.openDialog = $event),
        persistent: "",
        "max-width": "500px"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_card, {
          title: "Start Subscription",
          density: "compact"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [_createElementVNode("div", null, " Your subscription price will change, " + _toDisplayString(__props.plan.description.toLowerCase()) + ". ", 1)]),
            _: 1
          }), _createVNode(_component_v_divider), _createVNode(_component_v_card_actions, {
            class: "justify-end"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_v_card_actions, {
              class: "justify-end"
            }, {
              default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                class: "mr-4",
                onClick: cancel
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("Cancel", -1)]))]),
                _: 1
              }), _createVNode(LlSecondaryButton, {
                color: "primary",
                disabled: startSubscriptionState.loading,
                onClick: startSubscription
              }, {
                default: _withCtx(() => [_withDirectives(_createElementVNode("span", null, "Update LeanLaw Subscription", 512), [[_vShow, !startSubscriptionState.loading]]), _withDirectives(_createElementVNode("span", null, [...(_cache[2] || (_cache[2] = [_createElementVNode("span", {
                  class: "fa fa-cog fa-spin"
                }, null, -1), _createTextVNode(" Subscribing... ", -1)]))], 512), [[_vShow, startSubscriptionState.loading]])]),
                _: 1
              }, 8, ["disabled"])]),
              _: 1
            })])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};